import { render, staticRenderFns } from "./CoursewareStructuralElementDialogLink.vue?vue&type=template&id=ba812410&"
import script from "./CoursewareStructuralElementDialogLink.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementDialogLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports